import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, PropsWithChildren, useMemo } from 'react';
import { GeolocationManager } from 'record-it-utils/location/GeolocationManager/GeolocationManager';
import { GeolocationManagerGeolocationApiStrategy } from 'record-it-utils/location/GeolocationManager/strategy/GeolocationManagerGeolocationApiStrategy';
import { GeolocationManagerStrategy } from 'record-it-utils/location/GeolocationManager/strategy/GeolocationManagerStrategy';
import { GeolocationManagerContext, GeolocationManagerContextValue } from '../../context/GeolocationManagerContext';
import { prepareProps } from '../../utils/propUtils';
export type GeolocationManagerContextProviderProps = PropsWithChildren & {
  overrideStrategy?: GeolocationManagerStrategy;
};
export const GeolocationManagerContextProvider: FunctionComponent<GeolocationManagerContextProviderProps> = React.memo(props => {
  const $ = _c(11);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    overrideStrategy,
    children
  } = t0;
  let t1;
  if ($[2] !== overrideStrategy) {
    t1 = overrideStrategy ?? new GeolocationManagerGeolocationApiStrategy();
    $[2] = overrideStrategy;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = new GeolocationManager(t1);
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      manager: t2
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const contextValue = t3;
  let t4;
  if ($[8] !== children || $[9] !== contextValue) {
    t4 = <GeolocationManagerContext.Provider value={contextValue}>{children}</GeolocationManagerContext.Provider>;
    $[8] = children;
    $[9] = contextValue;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
});